import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";

const SlideComponent = ({ id, img, name }) => {
  const [isCursorEnter, setIsCursorEnter] = useState(false);
  const [currentId, setCurrentId] = useState(null);
  const price = parseFloat(id / 5000).toFixed(1);

  //   this function for copying the name to clipboard
  const [isClicked, setIsClicked] = useState(false);
  const ONClickCopy = (name) => {
    navigator.clipboard.writeText(name);
    setIsClicked(true);
  };
  useEffect(() => {
    const AutoTime = setTimeout(() => {
      setIsClicked(false);
    }, 2000);
    return () => {
      clearTimeout(AutoTime);
    };
  }, [isClicked]);
  return (
    <div className=" relative sli-rel-div w-full max-w-[350px] md:max-w-[400px] h-full flex justify-center">
      <img src={img} className=" relative slider-img" />
      <div
        onMouseEnter={() => {
          setIsCursorEnter(true);
          setCurrentId(id);
        }}
        onMouseOut={() => setIsCursorEnter(false)}
        className="absolute w-full h-[250px] md:h-[300px] md:top-[9%] top-[11%] left-0 bg-[rgba(0,0,0,0.3)] flex items-center justify-center text-slide-inside"
      >
        <div className="text-center">
          {isClicked && id === currentId && (
            <h4 className="h4-copied">Name copied to clipboard</h4>
          )}
          <div
            onMouseEnter={() => {
              setIsCursorEnter(true);
              setCurrentId(id);
            }}
          >
            <h1 className="text-[white] font-extrabold text-[25px] capitalize mb-1">
              {`${name.length > 10 ? name.slice(0,13):name}${name.length > 10 ? "...":""}`}
            </h1>
            <h1 className="font-extrabold text-[20px] text-[white] bg-[rgba(0,0,0,0.5)] py-[2px] px-1 rounded-full tracking-wider mb-1">
              Price: ${price}
            </h1>
          </div>
          <div
            className={`ab-slide-pic-btn-and-content show-two-button${
              isCursorEnter && id === currentId ? "" : ""
            }`}
          >
            <Link
              to={`/singlecocktail/${id}`}
              onMouseEnter={() => {
                setIsCursorEnter(true);
                setCurrentId(id);
              }}
            >
              <button className="btn-details-slide border-2 rounded-md text-[white] px-4 py-[2px] m-2 bg-[rgba(0,0,0,0.5)]">
                Details
              </button>
            </Link>
            <button
              onMouseEnter={() => {setIsCursorEnter(true)
                setCurrentId(id);
            }}
              onClick={() => {
                ONClickCopy(name);
              }}
              className="btn-details-slide border-2 rounded-md text-[white] px-4 py-[2px] m-2 bg-[rgba(0,0,0,0.5)]"
            >
              Copy Name
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SlideComponent;
